import React from 'react';

const ErrorState = ({ message = 'Something went wrong.', onRetry }) => (
  <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center gap-6 px-6 text-center">
    <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center text-3xl">⚠️</div>
    <h2 className="text-2xl font-black uppercase tracking-tighter text-white">Error</h2>
    <p className="text-zinc-400 font-bold max-w-sm">{message}</p>
    {onRetry && (
      <button onClick={onRetry} className="px-8 py-4 bg-white text-black font-black uppercase tracking-widest text-xs rounded-2xl">
        Retry
      </button>
    )}
  </div>
);

export default ErrorState;